import React from 'react'
import ProductPage from './ProductPage'

const ACCENT = '#16914c'
const ACCENT_2 = '#4ade80'

export const veyroTrainerData = {
  slug: 'veyro-trainer',
  accent: ACCENT,
  accent2: ACCENT_2,

  seo: {
    title: 'Veyro Trainer — Il tuo studio, in tasca',
    description: 'Veyro Trainer è l\'app per personal trainer: builder schede, gestione clienti, piani alimentari e vendita di pacchetti con payout automatico. Zero costi fissi, in beta test su iOS e Android.',
    canonical: '/veyro-trainer',
    schema: {
      name: 'Veyro Trainer',
      description: 'App per personal trainer: gestione clienti, builder schede di allenamento, piani alimentari, vendita di pacchetti e coaching con split payment Stripe Connect.',
      url: 'https://vmdproject.com/veyro-trainer',
      operatingSystem: 'iOS, Android',
      applicationCategory: 'BusinessApplication',
    },
  },

  eyebrow: '// veyro trainer',
  badge: 'Beta test — TestFlight / Play Internal',

  hero: {
    titleLead: 'Il tuo studio,',
    titleAccent: 'in tasca.',
    intro: 'L\'app dedicata ai personal trainer: costruisci schede e piani alimentari, segui i tuoi clienti, vendi pacchetti e coaching. Nessun canone mensile — guadagni tu, guadagniamo noi.',
    image: '/images/veyro-trainer/splash.webp',
    imageAlt: 'Veyro Trainer — splash screen dell\'app per personal trainer',
    ctaTo: '/collabora',
    ctaLabel: 'Richiedi accesso alla beta',
  },

  links: { privacy: '/veyro-trainer/policy', terms: '/veyro-trainer/terms' },

  related: {
    to: '/veyro',
    label: 'Cerchi l\'app per allenarti? Scopri Veyro',
    footerLabel: 'Veyro (app clienti)',
  },

  about: {
    eyebrow: "// cos'è veyro trainer",
    title: "L'app di lavoro del personal trainer.",
    text: [
      "Veyro Trainer è l'app mobile per iOS e Android con cui un personal trainer costruisce schede e piani alimentari, segue i propri clienti e vende pacchetti o coaching mensile agli utenti di Veyro.",
      "Non ha canone: la piattaforma trattiene una commissione solo sulle vendite e l'85% di ogni acquisto arriva al trainer tramite Stripe Connect.",
    ],
  },

  faq: [
    { q: 'Quanto costa Veyro Trainer?', a: "Nessun costo fisso mensile. La piattaforma trattiene una commissione solo quando vendi: a te arriva l'85% di ogni acquisto. I trainer fondatori non pagano commissioni per i primi 12 mesi." },
    { q: 'Cosa posso vendere?', a: 'Piani singoli una tantum (da €9,99 a €49,99) oppure abbonamenti di coaching mensile (da €30 a €100). Decidi tu cosa includono: allenamento, nutrizione, supporto.' },
    { q: 'Come ricevo i pagamenti?', a: "Con Stripe Connect Express: completi l'onboarding una volta e ogni acquisto viene diviso in automatico, con accredito diretto sul tuo conto." },
    { q: 'Come funziona la verifica del trainer?', a: 'Tre livelli: Base (automatico), Certificato (caricando la certificazione) e Top Trainer (rating di almeno 4,8 con almeno 20 recensioni). Il badge aumenta la visibilità nel marketplace.' },
    { q: 'Come si entra nella beta?', a: 'Scrivici dalla pagina Collabora: stiamo selezionando i primi personal trainer per TestFlight e Internal Testing.' },
  ],

  stats: [
    { icon: '💰', label: 'Costi fissi mensili', value: '€0', color: ACCENT_2 },
    { icon: '📤', label: 'Su ogni vendita', value: '85%', color: '#22d3ee' },
    { icon: '🏅', label: 'Livelli di verifica', value: '3', color: '#a78bfa' },
  ],

  features: {
    title: 'Tutti i tool professionali, senza canone.',
    lead: 'Trainerize, TrueCoach ed Everfit costano €50-150 al mese anche a zero clienti. Veyro Trainer non ha costi fissi: trattiene una commissione solo quando vendi davvero.',
    items: [
      {
        icon: '🧱',
        title: 'Builder Schede',
        desc: 'Crea schede da 800+ esercizi con filtri per categoria, difficoltà e gruppo muscolare. Superserie, serie e ripetizioni modificabili inline, assegnazione diretta al cliente.',
      },
      {
        icon: '👥',
        title: 'Gestione Clienti',
        desc: 'Lista clienti attivi con dettaglio, storico allenamenti e progressi. Ogni scheda assegnata arriva in tempo reale sull\'app del cliente.',
      },
      {
        icon: '📦',
        title: 'Pacchetti e Coaching',
        desc: 'Pubblica piani singoli una tantum (€9,99-49,99) o abbonamenti di coaching mensile (€30-100). Definisci cosa include: allenamento, nutrizione, supporto.',
      },
      {
        icon: '🥗',
        title: 'Piani Alimentari',
        desc: 'Editor strutturato con pasti, libreria alimenti Open Food Facts e calcolo automatico di calorie e macro — non più PDF e fogli di calcolo.',
      },
      {
        icon: '✅',
        title: 'Verifica e Recensioni',
        desc: 'Tre livelli: Base automatico, Certificato con upload della certificazione, Top Trainer con rating ≥4,8 e almeno 20 recensioni. Il badge aumenta la visibilità nel marketplace.',
      },
      {
        icon: '💳',
        title: 'Payout Automatici',
        desc: 'Onboarding Stripe Connect Express e split payment automatico su ogni acquisto: la commissione resta alla piattaforma, l\'85% arriva direttamente sul tuo conto.',
      },
    ],
  },

  stack: ['React Native', 'Expo', 'TypeScript', 'Supabase', 'Stripe Connect', 'Reanimated 4'],

  cta: {
    eyebrow: '// programma founder',
    titleLead: 'Allena con',
    titleAccent: 'Veyro Trainer.',
    text: 'Cerchiamo i primi personal trainer per la beta su TestFlight (iOS) e Internal Testing (Android). I PT fondatori non pagano commissioni per 12 mesi.',
    to: '/collabora',
    label: 'Candidati come PT',
  },
}

export default function VeyroTrainer() {
  return <ProductPage data={veyroTrainerData} />
}
